<template>
  <div class="farming-page">
		<div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner farming_banner">
			<div class="cover-content">
				<div class="bodyinfo">			
					<h2>智慧农业</h2>
					<p>精细化棚内调控服务</p>
					<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
				</div>
			</div>	
		</div>		
		<div class="farming-body">
			<div class="farming0">
				<div class="top">
					<p class="first-titile">方案设计架构</p>
					<p class="fu-title">数据采集+数据传输+云平台</p>
				</div>
				<div class="body">
					<img class="farming_framework" src="../../html/image/farming/farming_framework.png">
				</div>
			</div>
			<div class="farming01">
				<div class="top">
					<p class="first-titile">特色功能</p>
					<p class="fu-title">智慧农业生产管理系统</p>
				</div>
				<div class="body">
					<ul class="applicable-scenarios-list-container">
						<li class="item-scenarios-container">
							<img src="../../html/image/farming/trait_img1.png" alt="" class="scenarios-img">
							<p class="scenarios-name">专家库系统</p>
						</li>
						<li class="item-scenarios-container">
							<img src="../../html/image/farming/trait_img2.png" alt="" class="scenarios-img">
							<p class="scenarios-name"> 农业环境</p>
							<p class="scenarios-name">（监测+预警）</p>
						</li>
						<li class="item-scenarios-container">
							<img src="../../html/image/farming/trait_img3.png" alt="" class="scenarios-img">
							<p class="scenarios-name">远程联动</p>
							<p class="scenarios-name">控制管理</p>
						</li>
						<li class="item-scenarios-container">
							<img src="../../html/image/farming/trait_img4.png" alt="" class="scenarios-img">
							<p class="scenarios-name">农机管理</p>
						</li>
					</ul>
				</div>
			</div>
			<div class="farming02">
				<div class="top">
					<p class="first-titile">监测设备数据概览</p>
					<p class="fu-title">土壤检测&环境检测要素</p>
				</div>
				<div class="body">
					<ul class="device-list-container">
						<li class="device-item-container">
							<img class="device-item-img" src="../../html/image/farming/device_img1.png" alt="">
							<p class="device-title">水份／温度</p>
							<p class="device-tag device-tag1">土壤监测要素</p>
							<ul class="device-parameter-list-container">
								<li class="device-parameter-item-container">
									<span>
										水分量程：0～100%
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										温度量程：-40～80°C
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										水分精度：读数的3%（0～53%）读数的5%(53%~100%)
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										温度精度：0.5°C
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										响应时间：0<1S
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										输出信号：RS485/4～20mA／0～5V/0～10V
									</span>
								</li>
							</ul>
						</li>
						<li class="device-item-container">
							<img class="device-item-img" src="../../html/image/farming/device_img2.png" alt="">
							<p class="device-title">土壤EC电导率</p>
							<p class="device-tag device-tag1">土壤监测要素</p>
							<ul class="device-parameter-list-container">
								<li class="device-parameter-item-container">
									<span>
										量程：0～10000μs／cm
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										精度：10μs/cm
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										响应时间：<1S
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										输出信号：RS485/4～20mA／0～5V/0～10V
									</span>
								</li>
							</ul>
						</li>
						<li class="device-item-container">
							<img class="device-item-img" src="../../html/image/farming/device_img3.png" alt="">
							<p class="device-title">土壤PH值</p>
							<p class="device-tag device-tag1">土壤监测要素</p>
							<ul class="device-parameter-list-container">
								<li class="device-parameter-item-container">
									<span>
										直流供电：12～24V DC
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										耗电：≤5W（@12V DC，25°C）
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										测量精度：+0.5PH 
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										PH测量范围：0～14ph
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										长期稳定性：≤5%/y
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										输出信号：RS485输出(Mondbus协议）
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										工作温度：0～65°C
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										响应速度：≤15S
									</span>
								</li>
							</ul>
						</li>
						<li class="device-item-container">
							<img class="device-item-img" src="../../html/image/farming/device_img4.png" alt="">
							<p class="device-title">温湿度参数</p>
							<p class="device-tag device-tag2">环境监测要素</p>
							<ul class="device-parameter-list-container">
								<li class="device-parameter-item-container">
									<span>
										直流供电：内置锂电池
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										电池工作时长：≥3年
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										上报间隔：≥10min
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										采样间隔：10～720分钟可设置
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										通信制式：移动／电信NB-LOT网络
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										响应时间：≤15S（1m/s风速）
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										温度长期稳定性：≤0.1°C/year
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										湿度长期稳定性：≤1%/year
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										温度范围：-40°C～-80°C
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										湿度范围：0-100%RH 
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										温度分辨率：0.1
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										湿度分辨率：0.1%RH
									</span>
								</li>
							</ul>
						</li>
						<li class="device-item-container">
							<img class="device-item-img" src="../../html/image/farming/device_img5.png" alt="">
							<p class="device-title">光照强度传感器参数</p>
							<p class="device-tag device-tag2">环境监测要素</p>
							<ul class="device-parameter-list-container">
								<li class="device-parameter-item-container">
									<span>
										直流供电：内置锂电池
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										电池工作时长：≥3年
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										上报间隔：≥10min
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										采样间隔：10～720分钟可设置
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										通信制式：移动／电信NB-LOT网络
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										响应时间：≤15S（1m/s风速）
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										光照强度精度：±5%（25 °C）
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										光照强度：0-65535Lux/0-20万lux 
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										光照强度长期稳定性：≤15%／y
									</span>
								</li>
								<li class="device-parameter-item-container">
									<span>
										工作压力范围：0.9-1.1atm
									</span>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
			<div class="farming1">
				<div class="top">
					<p class="first-titile">智慧农业</p>
					<p class="fu-title">智慧农业生产管理优势</p>
				</div>
				<div class="body">
					<div class="body-left">
						<img id="new_img" src="../../html/image/farming/farming_new.png">
						<div class="farming-box">
							
						</div>
					</div>	
					<div class="body-right">
						<h2>远程监测</h2>
						<p>实时监测、预报预警、远程控制</p>
					</div>
					<div class="clear-float"></div>
				</div>
			</div>
			<div class="farming2">
				<div class="farming2-cover">
					
				</div>
				<div class="farming2-box">
					<span class="span1">数据分析</span>
					<span class="span2">历史数据分析、数据趋势分析、故障统计分析</span>
					<img class="img1" src="../../html/image/farming/farming_nr1_1.png">
					<span class="span3">实时监测</span>
					<span class="span4">设备分组、区域划分、实时预警</span>
					<img class="img2" src="../../html/image/farming/farming_nr1_2.png">
					<span class="span5">远程控制</span>
					<span class="span6">天窗、遮阳、水阀、壁灯、风机、水泵等远程控制</span>
					<img class="img3" src="../../html/image/farming/farming_nr3_2.png">
					<img class="img4" src="../../html/image/farming/farming_nr3_1.png">
				</div>	
			</div>
			<div class="farming3">
				
			</div>
		</div>
		<Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'farming',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  @import '../../html/css/zkm.css';
  @import '../../html/css/zkm.market.css';

	.farming-body .top{
		margin-bottom: 100px;
	}
	.farming-body .first-titile{
		margin-bottom: 18px;
	}
	.farming-body .farming1{
		padding-top: 84px;
	}
	.farming-body .farming1 .top{
		padding: 0px;
	}
	.farming-body  .fu-title{
		font-size: 16px;
		color: #384450;
		margin: 0;
	}
	.farming-body  .farming0 {
		padding-top: 58px;
	}
	.farming-body  .farming01 {
		padding-top: 88px;
		padding-bottom: 220px;
	}
	.farming-body  .farming0 .farming_framework{
		display: block;
		width: 100%;
		margin: 0 auto;
	}
	.farming-body .applicable-scenarios-list-container{
		margin-top: 86px;
	}
	.farming-body .applicable-scenarios-list-container .item-scenarios-container{
		float: left;
		width: 25%;
	}
	.farming-body .applicable-scenarios-list-container .scenarios-img{
		display: block;
		width: 155px;
		height: 178px;
		margin: 0 auto;
	}
	.farming-body .applicable-scenarios-list-container .scenarios-name{
		font-size: 32px;
		color: #333333;
		text-align: center;
	}
	.farming-body .applicable-scenarios-list-container .scenarios-name:not( :last-child ){
		margin-top: 26px;
	}
	.farming-body .farming02{
		padding: 92px 0px 170px;
		background: url('../../html/image/farming/farming_bg1.png') no-repeat center center;
		background-size: cover;
	}
	.farming-body .device-list-container{
		padding: 0px 80px;
		text-align: center;
	}
	.farming-body .device-list-container .device-item-container{
		float: left;
		width: 18%;
		height: 654px;
		padding: 48px 32px 0px;
		position: relative;
		background:rgba(255,255,255, 0.66);
		border:1px solid rgba(238,238,238,1);
		border-radius:14px;
	}
	.farming-body .device-list-container .device-item-container:not( :last-child ){
		margin-right: 2%;
	}
	.farming-body .device-list-container .device-item-container .device-item-img{
		display: block;
		max-width: 100%;
		height: 125px;
		margin: 0 auto;
	}
	.farming-body .device-list-container .device-item-container .device-title{
		font-size: 18px;
		color: #333333;
		text-align: center;
		margin: 20px 0px 26px;
	}
	.farming-body .device-list-container .device-item-container .device-tag{
		font-size: 18px;
		color: #FFFFFF;
		padding: 8px 12px;
		position: absolute;
		top: 0px;
		left: 0px;
	}
	.farming-body .device-list-container .device-item-container .device-tag1{
		background:rgba(41,120,205,1);
	}
	.farming-body .device-list-container .device-item-container .device-tag2{
		background:rgba(60,180,112,1);
	}
	.farming-body .device-list-container .device-item-container .device-parameter-list-container .device-parameter-item-container{
		font-size: 16px;
		color: #333333;
		text-align: left;
		line-height: 24px;
		margin-bottom: 8px;
	}
</style>